import { Reducer } from "../../lib/redux";
import { IamCredentialsActionTypes } from "./types";
import { IamCredentials, IamCredentialsActions } from "./actions";

export let defaultIamCredentials: IIdDictionary<IamCredentials> = {};

export let iamCredentials: Reducer<IIdDictionary<IamCredentials>, IamCredentialsActions> = (state = defaultIamCredentials, action) => {
    switch (action.type) {
        case IamCredentialsActionTypes.SET_IAM_USER: {
            const userName = action.payload.userName;
            if (userName) {
                return {
                    ...state,
                    [userName]: {
                        user: action.payload.user,
                        iamSettings: action.payload.iamSettings
                    }
                };
            }
            return state;
        }
        case IamCredentialsActionTypes.REMOVE_IAM_USER: {
            const userName = action.payload;
            let newState = { ...state };
            delete newState[userName];
            return newState;
        }
        default:
            return state;
    }
};